import React from 'react';
import MaterialIcon from '@/components/MaterialIcon';

/**
 * 产品介绍段落 - SEO优化新增
 * 自然融入高流量关键词，介绍GBase Support产品定位
 */
export const ProductIntroSection: React.FC = () => {
  return (
    <section className="w-full px-4 md:px-10 lg:px-40 py-16 bg-white">
      <div className="max-w-[900px] w-full mx-auto">
        <h2 className="text-2xl md:text-3xl font-black text-solution-text mb-6 text-center">
          商業施設向けAIチャットボットとは？
        </h2>
        <div className="space-y-4 text-solution-text-secondary text-base leading-relaxed">
          <p>
            GBase Supportは、商業施設・百貨店・ショッピングモール専用に開発されたAIチャットボットです。
            一般的なチャットボットと異なり、フロアマップとの連携機能を搭載し、
            「〇〇の店舗はどこですか？」といった店舗案内から、在庫確認、多言語対応まで、
            AIコンシェルジュとして包括的に対応します。
          </p>
          <p>
            従来、案内所で対応していた問い合わせの50~70%を自動化し、
            スタッフの負担を大幅に軽減。訪日外国人（インバウンド）対応にも威力を発揮する、 次世代の店舗案内AIです。
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProductIntroSection;
